import type { SupabaseConfigError } from "@/api/supabaseClient";
import { useTheme } from "@/theme/ThemeProvider";
import { ErrorState } from "@/ui/components/StateViews";
import { Platform, StyleSheet, Text, View } from "react-native";

/**
 * Sichtbarer Ersatz für die weiße Seite, wenn der Build ohne
 * EXPO_PUBLIC_SUPABASE_URL / EXPO_PUBLIC_SUPABASE_ANON_KEY ausgeliefert wurde.
 * Keine zweite Auth-Schranke — die bleibt allein im Root-Layout.
 */
export function SupabaseConfigErrorScreen({ error }: { error: SupabaseConfigError }) {
  const { theme } = useTheme();

  return (
    <View
      style={[
        styles.root,
        {
          backgroundColor: theme.color.bg,
          padding: theme.space.lg,
        },
        Platform.OS === "web" && styles.web,
      ]}
      {...(Platform.OS === "web" ? { dataSet: { fcShell: "1" } } : {})}
    >
      <View style={[styles.panel, { gap: theme.space.md, maxWidth: theme.layout.readable }]}>
        <Text
          style={{
            color: theme.color.text,
            fontSize: theme.fontSize.h2,
            fontWeight: "700",
            textAlign: "center",
          }}
        >
          Konfiguration fehlt
        </Text>
        <ErrorState message={error.message} />
      </View>
    </View>
  );
}

const styles = StyleSheet.create({
  root: {
    flex: 1,
    alignItems: "center",
    justifyContent: "center",
  },
  web: {
    minHeight: "100vh" as unknown as number,
    width: "100%" as unknown as number,
  },
  panel: {
    width: "100%",
  },
});
